export const LOADING_SALES_TODAY = "LOADING_SALES_TODAY";
export const SET_SALES_TODAY = "SET_SALES_TODAY";
export const LOADING_SALES_THIS_MONTH = "LOADING_SALES_THIS_MONTH";
export const SET_SALES_THIS_MONTH = "SET_SALES_THIS_MONTH";
export const LOADING_SALES_THIS_YEAR = "LOADING_SALES_THIS_YEAR";
export const SET_SALES_THIS_YEAR = "SET_SALES_THIS_YEAR";
export const LOADING_OVERALL_SALES = "LOADING_OVERALL_SALES";
export const SET_OVERALL_SALES = "SET_OVERALL_SALES";
